import React from 'react';
import { Circle } from 'react-konva';

const VertexHandle = ({
  x,
  y,
  radius,
  color,
  hoverColor,
  strokeColor = '#FFFFFF',
  onMouseDown,
  onTouchStart,
  onContextMenu,
  stageScale = 1,
}) => {
  const strokeW = Math.max(0.5, 1 / stageScale);

  return (
    <Circle
      x={x}
      y={y}
      radius={radius}
      fill={color}
      stroke={strokeColor}
      strokeWidth={strokeW}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onContextMenu={(e) => e.evt.preventDefault()}
      onMouseEnter={(e) => {
        if (hoverColor) {
          e.target.fill(hoverColor);
          e.target.getLayer()?.batchDraw();
        }
      }}
      onMouseLeave={(e) => {
        e.target.fill(color);
        e.target.getLayer()?.batchDraw();
      }}
      listening={true}
      perfectDrawEnabled={false}
    />
  );
};

export default VertexHandle;
